export default "__VITE_ASSET__30QK0_IE__"